
    var riot = require('riot')
    //src: starling/src/tags/child-nodes.html
riot.tag2('child-nodes',
  '<div class="child-nodes-container {!this.parent.getIsNarrow().children && this.parent.instance.getGoverningLayoutName() == \'layout-row\' && \'wrappable-children\'}" ref="container" riot-style="{this.getContainerStyle()} display: {(this.parent.instance.getLayoutName() == \'layout-freehand\' || this.parent.instance.children().length) && !this.parent.instance.getIsCollapsed() ? \'block\' : \'none\'};" onmouseenter="{handleMouseEnter}" onmouseleave="{handleMouseLeave}" data-id="{id}" onclick="{handleClick}" oncontextmenu="{handleRightClick}"> <div ref="menuTool" class="menu-tool"></div> <svg if="{parent.instance.getChildrenDetached()}" class="shadow {parent.instance.getChildrenDetached() ? \'\' : \'hidden\'}" ref="shadowsvg"> <mask id="shadow-clip-path-{id}"> <rect width="10000" height="10000" x="-5000" y="-5000" fill="white"></rect> <path style="fill: black" riot-d="{this._shadowPath.clip}" ref="clippath"></path> </mask> <path riot-d="{this._shadowPath.path}" ref="shadowpath" mask="url(#shadow-clip-path-{id})"> </svg> <h6 if="{parent.instance.getChildrenDetached()}" ref="detachedTitle" class="detached-title shadow-text">{parent.title}</h6> <div class="child-nodes {parent.instance.childrenHaveChildren() ? \'has-nested-children\' : \'\'} {this.layoutName}" ref="childNodes"> <div if="{parent.instance.getChildrenDetached() || layoutName === \'layout-freehand\'}" class="screen {layoutName === \'layout-freehand\' ? \'panzoomable\' : \'\'}" ref="screen" ondblclick="{screenDoubleClick}" onclick="{screenClick}"> </div> <div class="resize-handle" ref="resizeHandle"></div> <node each="{parent.instance.children()}" instance="{this}" child="{true}"></node> <div ref="partBarTool" class="part-anchor {this.parent.instance.getLayoutName()}" hide="{this.canvas.isViewOnly()}"> </div> </div> </div> <div ref="containerCollapsed" class="child-nodes-collapsed" riot-style="display: {!this.parent.instance.getIsCollapsed() ? \'none\' : \'block\'}"> <div class="container-collapsed-children c-pointer" onclick="{parent.toggleExpansion}" ondblclick="{parent.ignoreDblClick}" title="expand"> <i each="{parent.instance.children()}" class="fa fa-circle collapsed-dot {this.children().length ? \'grandchildren\' : \'\'}" aria-hidden="true" data-id="{this.id}"></i> </div> </div>',
  '',
  'class="{parent.instance.getChildrenDetached() ? \'detached\' : \'attached\'} children-frontage {this.layoutName} {opts.class}" ref="main" oncontextmenu="{stopRightClickPropagation}"', function(opts) {
'use strict';

var _this = this;

var _nodesUi = require('lib/nodes-ui');

var _constants = require('lib/constants');

var _interactjs = require('interactjs');

var _interactjs2 = _interopRequireDefault(_interactjs);

var _resizeObserverPolyfill = require('resize-observer-polyfill');

var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);

var _util = require('lib/util');

var _nodeDragHandlers = require('lib/node-drag-handlers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var self = this;
this.offset = 0;
this.operation = this.parent.operation;
this.canvas = this.parent.canvas;
this.parent.childNodesTag = this;
this.id = this.parent.id;
this.canvas.childNodeTags[this.id] = this;
this.layoutName = this.parent.instance.getLayoutName();
this._shadowPath = { clip: 'M 0 0', path: 'M 0 0' };

this.handleClick = function (e) {
  if (_this.canvas.linkDragging) return;
  if (self.parent.mousePannable(e)) {
    return;
  }
  // don't expand our distant parent on click
  if (_this.parent.instance.getChildrenDetached()) {
    e.preventDefault();
    e.stopPropagation();
  }
  if (_this.layoutName == 'layout-freehand') {
    e.preventDefault();
    e.stopPropagation();
  }
  _this.canvas.clearSelectedElements();
};

this.topLevelParentTag = function () {
  return _this.parent;
};

this.handleMouseEnter = function (e) {
  e.preventUpdate = true;

  if (_this.parent.instance.getChildrenDetached() && !_this.dragging) {

    _this.canvas.setMouseEnteredPopout(_this);

    _this.canvas.nodeTools.summon({
      node: _this,
      summonedFromChildNodes: true,
      hideRelationshipTool: true,
      hidePerspectiveTool: true,
      positionReferenceElement: _this.refs.container
    });
  }
};

this.handleMouseLeave = function (e) {
  _this.refs.container.classList.remove('top-hover');
  _this.canvas.clearMouseEnteredNode();
};

this.on('update', function () {
  _this.layoutName = _this.parent.instance.getLayoutName();
  _this._shadowPath = _this.getShadowPath();
  _this.enableDragging();
});

this.on('updated', function () {
  (0, _nodeDragHandlers.setupHandleResizing)({
    canvas: _this.canvas,
    handleRef: _this.refs.resizeHandle,
    nodeTag: _this.parent
  });
});

this.updateFormat = function () {
  _this.updateDisplay();

  if (_this.parent.parentTag()) {
    _this.parent.parentTag().childNodesTag.fitToContents();
  }
};

this.updateDisplay = function () {
  var node = store.getNode(_this.id);
  if (!node) return;
  if (!_this.refs) return;
  if ((node.getLayoutName() === 'layout-freehand' || node.children().length) && !node.getIsCollapsed()) {
    if (_this.refs.container) {
      _this.refs.container.style.display = 'block';
    }
  } else {
    if (_this.refs.container) {
      _this.refs.container.style.display = 'none';
    }
  }

  if (!node.getIsCollapsed()) {
    if (_this.refs.containerCollapsed) {
      _this.refs.containerCollapsed.style.display = 'none';
      if (_this.reclipTimeout) clearTimeout(_this.reclipTimeout);
      _this.reclipTimeout = setTimeout(function () {
        return _this.reclipLinks();
      }, 10);
    }
  } else {
    if (_this.refs.containerCollapsed) {
      _this.refs.containerCollapsed.style.display = 'block';
      _this.reclipLinks();
    }
  }
};

this.reclipLinks = function () {
  var _parent$instance = _this.parent.instance,
      absolutePosition = _parent$instance.absolutePosition,
      childrenPosition = _parent$instance.childrenPosition;
  var width = childrenPosition.width,
      height = childrenPosition.height;

  var left = absolutePosition.x + childrenPosition.x;
  var top = absolutePosition.y + childrenPosition.y;

  var rect = {
    left: left,
    top: top,
    right: left + width,
    bottom: top + height,
    width: width,
    height: height
  };

  var unscaledRect = (0, _util.unscaleRect)({ rect: rect, canvas: canvas });
  _nodesUi.nui.reclipLink(unscaledRect, _this);
};

this.updatePosition = function () {
  var node = store.getNode(_this.id);
  // only set x and y coords if we're in freehand mode or we're a top level node
  if (self.refs.container) {
    if (node.getChildrenDetached()) {
      self.refs.container.style.left = node.childrenPosition.x + 'px';
      self.refs.container.style.top = node.childrenPosition.y + 'px';
    } else {
      self.refs.container.style.left = '';
      self.refs.container.style.top = '';
    }
  }
  _this.reclipLinks();
};

this.updateShadow = function () {
  if (!_this.refs.shadowpath) {
    return;
  }

  var _getShadowPath = _this.getShadowPath(),
      path = _getShadowPath.path,
      clip = _getShadowPath.clip;

  var _refs = _this.refs,
      shadowpath = _refs.shadowpath,
      shadowsvg = _refs.shadowsvg,
      clippath = _refs.clippath;

  shadowpath.setAttribute('d', path);
  clippath.setAttribute('d', clip);

  var node = store.getNode(_this.id);
  if (node && node.getChildrenDetached()) {
    shadowsvg.classList.remove('hidden');
  } else {
    shadowsvg.classList.add('hidden');
  }
};

this.updateDetachment = function () {
  var temp = store.getNode(_this.id);
  if (temp && temp.children().length) {
    if (temp.getChildrenDetached()) {
      _this.refs.main.classList.add('detached');
      _this.refs.main.classList.remove('attached');
      _this.parent.refs.partBarTool.classList.add('parts-popped-out');
    } else {
      _this.refs.main.classList.remove('detached');
      _this.refs.main.classList.add('attached');
      _this.parent.refs.partBarTool.classList.remove('parts-popped-out');
    }
  }
};

this.getContainerStyle = function () {
  var node = store.getNode(_this.id);
  if (!node) return '';
  if (node.getChildrenDetached()) {

    var dimensionsStyle = node.getLayoutName() !== 'layout-freehand' ? 'min-width: ' + node.childrenPosition.userWidth + 'px; min-height: ' + node.childrenPosition.userHeight + 'px' : '';

    var positionStyle = 'top: ' + (_this.offset + node.childrenPosition.y) + 'px; left: ' + (_this.offset + node.childrenPosition.x) + 'px;';

    return dimensionsStyle + '; ' + positionStyle;
  }
  return '';
};

this.positionMenuTag = function (_ref) {
  var triggerRef = _ref.triggerRef;
  var canvas = _this.canvas;
  var nodeMenuTag = canvas.nodeMenuTag;
  var SIDEBAR_WIDTH = _constants.WIDTHS.SIDEBAR_WIDTH,
      NODE_MENU_WIDTH = _constants.WIDTHS.NODE_MENU_WIDTH,
      TAG_POPOVER_WIDTH = _constants.WIDTHS.TAG_POPOVER_WIDTH;

  var rightCanvasEdge = canvas.sidebarStatus === 'closed' ? window.innerWidth : window.innerWidth - SIDEBAR_WIDTH;

  var rect = _this.refs.container.getBoundingClientRect();
  var _rect = rect,
      y = _rect.top,
      x = _rect.right;

  var menuRect = _this.refs.menuContainer.getBoundingClientRect();

  var positionToLeft = rightCanvasEdge - menuRect.right < NODE_MENU_WIDTH;
  var positionSubToLeft = rightCanvasEdge - menuRect.right < NODE_MENU_WIDTH + TAG_POPOVER_WIDTH;

  if (positionToLeft) {
    rect = menuRect;
  }

  nodeMenuTag.summon({
    x: x, y: y,
    nodeRect: rect,
    positionToLeft: positionToLeft,
    positionSubToLeft: positionSubToLeft,
    node: _this.parent,
    childNodes: true,
    triggerRef: triggerRef
  });
};

this.toggleMenu = function (e) {
  var canvas = _this.canvas;
  var nodeMenuTag = canvas.nodeMenuTag;

  if (canvas.isViewOnly()) {
    return;
  }

  e.stopPropagation();

  if (nodeMenuTag.summoned && nodeMenuTag.node.id == _this.id && nodeMenuTag.childNodes) {
    nodeMenuTag.hide();
  } else {
    _this.positionMenuTag({
      triggerRef: _this.refs.menuContainer
    });
  }
};

this.dragging = false;
var prevX = void 0;
var prevY = void 0;
this.enableDragging = function () {
  var node = store.getNode(_this.id);
  if (_this.dragger) _this.dragger.off();
  if (!node.getChildrenDetached()) {
    _this.dragger = (0, _interactjs2.default)(self.refs.container).actionChecker(function (pointer, event, action) {
      if (event.target.classList.contains('resize-handle')) return null;
      return action;
    }).styleCursor(false).draggable(false);
    return;
  }
  _this.dragger = (0, _interactjs2.default)(self.refs.container).styleCursor(false).draggable({
    onstart: function onstart(e) {
      if (_this.canvas.isViewOnly()) {
        return;
      }
      if (!_this.parent.instance.getChildrenDetached()) {
        return;
      }
      prevX = node.childrenPosition.x;
      prevY = node.childrenPosition.y;
      e.preventDefault();
      e.stopPropagation();
      self.parent.canvas.disablePanZoom();
      self.refs.main.classList.add('children-dragging');
      document.body.classList.add('dragging-children');
    },
    onmove: function onmove(e) {
      if (_this.canvas.isViewOnly()) {
        return;
      }
      if (!_this.parent.instance.getChildrenDetached()) {
        return;
      }
      _this.canvas.nodeTools.hide();
      _this.dragging = true;
      e.preventDefault();
      e.stopPropagation();
      var scale = self.parent.canvas.getMatrix().scale;
      var dx = e.dx / scale;
      var dy = e.dy / scale;

      node.childrenPosition.x = self.parent.instance.childrenPosition.x += dx;
      node.childrenPosition.y = self.parent.instance.childrenPosition.y += dy;

      var appliedMoveLookup = {};
      self.parent.instance.applyMove({ dx: dx, dy: dy, appliedMoveLookup: appliedMoveLookup, canvas: self.canvas, onlyApplyToChildren: true });

      self.updatePosition();
      self.updateDisplay();
      self.updateShadow();

      try {
        self.parent.updateNodesDisplayRecursively({ ignoreRefreshFreehandAncestors: true });
        self.parent.topLevelParentTag().rediscoverLinkPositions();
      } catch (e) {
        console.log(e);
      }
    },
    onend: function onend(e) {
      if (_this.canvas.isViewOnly()) {
        return;
      }
      _this.dragging = false;
      if (!_this.parent.instance.getChildrenDetached()) {
        return;
      }
      self.parent.canvas.enablePanZoom();

      self.refs.main.classList.remove('children-dragging');
      document.body.classList.remove('dragging-children');
      var rect = self.refs.container.getBoundingClientRect();
      var parentRect = self.parent.refs.container.getBoundingClientRect();

      if (!(rect.right < parentRect.left || parentRect.right < rect.left || rect.bottom < parentRect.top || parentRect.bottom < rect.top)) {
        node.childrenPosition.x = self.parent.instance.childrenPosition.x = parentRect.width + 20;
        node.childrenPosition.y = self.parent.instance.childrenPosition.y = rect.height / -2;
      }
      self.parent.updateTopLevelNeighborsLite();
      _this.operation.setChildrenPosition({
        nodeUUID: self.parent.id,
        prevX: prevX,
        prevY: prevY,
        prevUserWidth: node.childrenPosition.userWidth || null,
        prevUserHeight: node.childrenPosition.userHeight || null,
        x: node.childrenPosition.x,
        y: node.childrenPosition.y,
        userWidth: node.childrenPosition.userWidth || null,
        userHeight: node.childrenPosition.userHeight || null,
        onFailure: function onFailure(err) {
          console.warn('setChildrenPosition failed');
        }
      });
    }
  });
};

this.on('mount', function () {
  if (_this.canvas.isViewOnly()) {
    return;
  }
  if (_this.parent.instance.getChildrenDetached()) {
    _this.dragger = _this.enableDragging();
  }

  if (_this.parent.getLayoutName() == 'layout-freehand') {
    (0, _nodeDragHandlers.setupHandleResizing)({
      canvas: _this.canvas,
      handleRef: _this.refs.resizeHandle,
      nodeTag: _this.parent
    });
  }

  var _canvas$getMatrix = _this.canvas.getMatrix(),
      scale = _canvas$getMatrix.scale;

  _this.resizeObserver = new _resizeObserverPolyfill2.default(function (entries) {
    if (_this.parent.instance.getLayoutName() !== 'layout-freehand') return;
    for (var _iterator = entries, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref2;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref2 = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref2 = _i.value;
      }

      var entry = _ref2;

      if (entry.target == _this.refs.container) {
        _this.parent.instance.childrenPosition.width = entry.contentRect.width / scale;
        _this.parent.instance.childrenPosition.height = entry.contentRect.height / scale;
      }
    }
  });
  _this.resizeObserver.observe(_this.refs.container);
});

this.fitToContents = function (opts) {
  opts = Object.assign({ extraSpace: false }, opts || {});
  var container = _this.refs.childNodes;

  var _parent$instance$chil = _this.parent.instance.childrenPosition,
      userWidth = _parent$instance$chil.userWidth,
      userHeight = _parent$instance$chil.userHeight;

  if (_this.layoutName == 'layout-freehand') {

    // find children extents...
    var et = Infinity,
        el = Infinity,
        eb = -Infinity,
        er = -Infinity;

    for (var _iterator2 = _this.parent.instance.children(), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
      var _ref3;

      if (_isArray2) {
        if (_i2 >= _iterator2.length) break;
        _ref3 = _iterator2[_i2++];
      } else {
        _i2 = _iterator2.next();
        if (_i2.done) break;
        _ref3 = _i2.value;
      }

      var child = _ref3;

      var cr = child.x + child.width;
      var cb = child.y + child.height;
      var cl = child.x;
      var ct = child.y;
      if (cr > er) er = cr;
      if (cb > eb) eb = cb;
      if (ct < et) et = ct;
      if (cl < el) el = cl;
    }

    var imageWidth = _this.parent.instance.attachedFile && _this.parent.instance.attachedFile.display_properties && _this.parent.instance.attachedFile.display_properties.width || 0;

    var imageHeight = _this.parent.instance.attachedFile && _this.parent.instance.attachedFile.display_properties && _this.parent.instance.attachedFile.display_properties.height || 0;

    var containerWidth = Math.max(er, 80);
    var containerHeight = Math.max(eb, 80);

    if (container) {

      var extraWidth = opts.extraSpace ? 300 : _constants.FREEHAND_PADDING;

      container.style.width = Math.max(containerWidth + extraWidth, userWidth || 0, _this.parent.instance.userWidth || 0, imageWidth) + 'px';
      container.style.height = Math.max(containerHeight + _constants.FREEHAND_PADDING, userHeight || 0, _this.parent.instance.userHeight || 0, imageHeight) + 'px';

      var parentNodeTags = _this.parent.canvas.nodeTags[_this.parent.id];
    }
  } else {
    var _container = _this.refs.childNodes;
    if (_container) {
      _container.style.width = 'auto';
      _container.style.height = 'auto';
    }
  }
};

this.getShadowPath = function () {
  var node = store.getNode(_this.id);
  if (!node || !node.getChildrenDetached()) {
    return { path: 'M 0 0' };
  }
  var sb = _this.refs.container.getBoundingClientRect();
  var pb = _this.parent.refs.backdrop.getBoundingClientRect();
  var scale = 1 / _this.parent.canvas.getMatrix().scale;
  var x0 = 0,
      y0 = 0,
      x1 = 0,
      y1 = 0,
      x2 = 0,
      y2 = 0,
      x3 = 0,
      y3 = 0;

  var diffX = 2 / scale;
  var diffY = 28 / scale;
  var margin = 20 / scale;
  var clip = 'm ' + (pb.left - sb.left) * scale + ' ' + (pb.top - sb.top) * scale + ' h ' + pb.width * scale + ' v ' + pb.height * scale + ' h -' + pb.width * scale;

  if (pb.right <= sb.left - sb.width / 2 || pb.right <= sb.left && !(pb.bottom <= sb.top || pb.top >= sb.bottom)) {
    x0 = 0;
    // avoid showing a sliver of shadow if we're above or below
    // and don't hide shadow completely if we're too close
    // placement to the right

    y0 = 0;
    x1 = 0;
    y1 = (sb.bottom - sb.top) * scale;
    x2 = (pb.left - sb.left + pb.width - margin) * scale;
    y2 = (pb.bottom - sb.bottom - pb.height + diffY) * scale;
    x3 = 0;
    y3 = 0;
  } else if (pb.left >= sb.right + sb.width / 2 || pb.left >= sb.right && !(pb.bottom <= sb.top || pb.top >= sb.bottom)) {
    x0 = (sb.right - sb.left) * scale;

    // placement to the left;

    y0 = 0;
    x1 = 0;
    y1 = (sb.bottom - sb.top) * scale;
    x2 = (pb.left - sb.right + diffX + margin) * scale;
    y2 = (pb.bottom - sb.bottom - pb.height + diffY) * scale;
    x3 = 0;
    y3 = 0;
  } else if (pb.bottom <= sb.top) {
    x0 = 0;

    // placement to the bottom

    y0 = 0;
    x1 = (pb.left - sb.left + diffX + pb.width / 2) * scale;
    y1 = (pb.bottom - sb.top - margin) * scale;
    x2 = 0;
    y2 = 0;
    x3 = (sb.right - pb.right + pb.width / 2 - diffX) * scale;
    y3 = (sb.top - pb.bottom + margin) * scale;
  } else if (pb.top >= sb.bottom) {
    x0 = 0;
    // placement to the top

    y0 = (sb.bottom - sb.top) * scale;
    x1 = (pb.left - sb.left + pb.width / 2) * scale;
    y1 = (pb.top - sb.bottom + margin) * scale;
    x2 = 0;
    y2 = 0;
    x3 = (sb.right - pb.right + pb.width / 2) * scale;
    y3 = (sb.bottom - pb.top - margin) * scale;
  } else {
    return { path: "M 0 0" };
  }

  return {
    path: 'M ' + x0 + ' ' + y0 + ' l ' + x1 + ' ' + y1 + ' l ' + x2 + ' ' + y2 + ' l ' + x3 + ' ' + y3,
    clip: clip
  };
};

this.screenClick = function (e) {
  if (!_this.canvas.linkDragging) {
    e.stopPropagation();
  }
};

this.screenDoubleClick = function (e) {
  _this.parent.handleAddPart(e);
};

this.updateDetachedTitle = function () {
  var title = _this.canvas.store.getNode(_this.parent.id).title;
  _this.refs.detachedTitle.innerText = title;
};

this.handleRightClick = function (e) {
  if (e.altKey) return;
  var isPopoutMenu = _this.parent.instance.getChildrenDetached() ? true : false;
  var isFreehandMenu = _this.parent.instance.getLayoutName() == 'layout-freehand' ? true : false;
  if (isPopoutMenu || isFreehandMenu) {
    if (!e.shiftKey) {
      e.preventDefault();
      e.stopPropagation();
      _this.canvas.rightClickMenu.summon({
        x: e.clientX,
        y: e.clientY,
        nodeTag: _this.parent,
        isPopoutMenu: isPopoutMenu,
        isFreehandMenu: isFreehandMenu
      });
    }
  }
};

this.stopRightClickPropagation = function (e) {
  e.stopPropagation();
  e.stopImmediatePropagation();
  _this.canvas.hidePopups();
};

this.parent.childNodesTag = this;
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('child-nodes')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/child-nodes.html
// module id = 607
// module chunks = 0